import {h, Fragment} from "preact"
import { useFacets, useSort } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import { sortOptions } from "../config"
import SelectInsideSidebar from "./elements/SelectInsideSidebar"


export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for={toggleButtonId}
        >
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L17.875 18" stroke="black"></path>
            <path d="M17.875 1L0.999999 18" stroke="black"></path>
            </svg>
        </label>
    )
}

export default function SideBar() {

    const { loading, facets } = useFacets()
    const { activeSort, setSort } = useSort(sortOptions)
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div
                class="ns-sidebar-wrapper ns-h-100 ns-col-3 ns-col-l-2"
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline ns-p-4">
                        <span class="ns-font-medium ns-color-black" style="font-size: 21px;">SORT + FILTER</span>
                        <ToggleSidebarButton />
                    </div>
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                        <SelectInsideSidebar 
                                value={activeSort}
                                className="ns-selection-dropdown-sort-menu"
                                options={options}
                                label={"Sort by"}
                                />
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
